import { ListToolbarComponent } from './list-toolbar.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [ListToolbarComponent],
  imports: [CommonModule],
  exports: [ListToolbarComponent]
})
export class ListToolbarModule {}
